module.exports = __webpack_public_path__ + "static/img/software14.25a4c747.png";